<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-truck text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Veículos</h4>
            <small class="text-muted small">Gerenciamento de veículos e frotas</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <div style="min-width: 130px" class="mr-2">
                        <b-form-select 
                            v-model="situacaoFiltro" 
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @change="pesquisar()">
                            <b-form-select-option value="9">Todos</b-form-select-option>
                            <b-form-select-option value="1">Ativos</b-form-select-option>
                            <b-form-select-option value="0">Inativos</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div style="min-width: 150px" class="mr-2">
                        <b-form-select 
                            v-model="tipoFiltro" 
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @change="pesquisar()">
                            <b-form-select-option value="0">Todos os Tipos</b-form-select-option>
                            <b-form-select-option value="1">Carro</b-form-select-option>
                            <b-form-select-option value="2">Moto</b-form-select-option>
                            <b-form-select-option value="3">Cavalinho</b-form-select-option>
                            <b-form-select-option value="4">Carreta</b-form-select-option>
                            <b-form-select-option value="5">Caçamba</b-form-select-option>
                            <b-form-select-option value="6">Trator</b-form-select-option>
                            <b-form-select-option value="7">Balsa</b-form-select-option>
                            <b-form-select-option value="8">Barco</b-form-select-option>
                            <b-form-select-option value="9">Caminhão</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div style="min-width: 250px">
                        <b-form-input 
                            v-model="textoPesquisa" 
                            placeholder="Buscar por nome ou placa..."
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Novo Veículo</span>
            </b-button>
        </div>
      </div>

      <!-- Table Premium -->
      <div class="table-responsive">
        <b-table
          id="table-veiculo"
          :items="lista"
          :fields="fields"
          hover
          striped
          small
          show-empty
          class="mb-0"
          thead-class="bg-light"
          tbody-tr-class="cursor-pointer"
          @row-clicked="edit"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Carregando...</strong>
            </div>
          </template>

          <template #empty>
            <div class="text-center text-muted my-3">
              <i class="fa fa-info-circle fa-2x mb-2"></i>
              <p class="mb-0">Nenhum veículo encontrado</p>
            </div>
          </template>

          <template #cell(ID)="row">
            <div class="d-flex align-items-center">
                <div>
                    <div class="font-weight-bold text-primary">#{{ row.item.ID }}</div>
                    <small class="text-muted">{{ row.item.PLACA }}</small>
                </div>
            </div>
          </template>

          <template #cell(NOME)="row">
            <div>
              <div class="font-weight-semibold">{{ row.item.NOME }}</div>
              <small class="text-muted">{{ row.item.MODELO }}</small>
            </div>
          </template>

          <template #cell(OP_TIPO)="row">
            <b-badge :variant="getTipoVariant(row.item.OP_TIPO)" class="px-3 py-1">
              {{ getTipoLabel(row.item.OP_TIPO) }}
            </b-badge>
          </template>

          <template #cell(MARCA)="row">
            <span>{{ row.item.MARCA }}</span>
          </template>

          <template #cell(ANO)="row">
            <span>{{ row.item.ANO }}</span>
          </template>

          <template #cell(OP_COMBUSTIVEL)="row">
            <b-badge :variant="getCombustivelVariant(row.item.OP_COMBUSTIVEL)" class="px-2 py-1">
              {{ getCombustivelLabel(row.item.OP_COMBUSTIVEL) }}
            </b-badge>
          </template>

          <template #cell(PROPRIETARIO_NOME)="row">
            <span class="text-truncate" style="max-width: 200px; display: inline-block;">
              {{ row.item.PROPRIETARIO_NOME }}
            </span>
          </template>

          <template #cell(OP_SITUACAO)="row">
            <b-badge :variant="row.item.OP_SITUACAO === '1' ? 'success' : 'danger'" class="px-3 py-1">
              {{ row.item.OP_SITUACAO === '1' ? 'Ativo' : 'Inativo' }}
            </b-badge>
          </template>

          <template #cell(actions)="row">
            <b-button-group size="sm">
              <b-button variant="outline-primary" @click.stop="edit(row.item)" v-b-tooltip.hover title="Editar">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button variant="outline-danger" @click.stop="excluir(row.item)" v-b-tooltip.hover title="Excluir">
                <i class="fa fa-trash"></i>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Modal de Confirmação -->
    <b-modal
      id="modal-excluir"
      title="Confirmar Exclusão"
      @ok="confirmarExclusao"
      ok-title="Sim, Excluir"
      cancel-title="Cancelar"
      ok-variant="danger"
      cancel-variant="secondary"
    >
      <p>Tem certeza que deseja excluir o veículo <strong>{{ veiculoSelecionado ? veiculoSelecionado.NOME : '' }}</strong>?</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tools from '../../../tools/Tools'

export default {
  name: 'VeiculoListagem',
  data () {
    return {
      situacaoFiltro: '9',
      tipoFiltro: '0',
      textoPesquisa: '',
      lista: [],
      veiculoSelecionado: null,
      fields: [
        {
          key: 'ID',
          label: 'Código',
          sortable: true,
          thStyle: 'width: 120px;'
        },
        {
          key: 'NOME',
          label: 'Nome/Modelo',
          sortable: true
        },
        {
          key: 'OP_TIPO',
          label: 'Tipo',
          sortable: true,
          thStyle: 'width: 120px;'
        },
        {
          key: 'MARCA',
          label: 'Marca',
          sortable: true,
          thStyle: 'width: 150px;'
        },
        {
          key: 'ANO',
          label: 'Ano',
          sortable: true,
          thStyle: 'width: 80px;'
        },
        {
          key: 'OP_COMBUSTIVEL',
          label: 'Combustível',
          sortable: true,
          thStyle: 'width: 120px;'
        },
        {
          key: 'PROPRIETARIO_NOME',
          label: 'Proprietário',
          sortable: true,
          thStyle: 'width: 200px;'
        },
        {
          key: 'OP_SITUACAO',
          label: 'Situação',
          sortable: true,
          thStyle: 'width: 100px;'
        },
        {
          key: 'actions',
          label: 'Ações',
          thStyle: 'width: 110px; text-align: center;'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('veiculo', [
      'recarregarLista'
    ]),
    isDark () {
      return this.$store.getters.getTheme === 'dark'
    }
  },
  watch: {
    recarregarLista (val) {
      if (val) {
        this.pesquisar()
        this.$store.commit('veiculo/SET_RECARREGAR_LISTA', false)
      }
    }
  },
  mounted () {
    // Restaurar filtros do store
    this.situacaoFiltro = this.$store.getters['veiculo/situacao']
    this.tipoFiltro = this.$store.getters['veiculo/tipo']
    this.textoPesquisa = this.$store.getters['veiculo/textoPesquisa']
    
    // Carregar lista inicial
    this.pesquisar()
  },
  methods: {
    async pesquisar () {
      this.$store.commit('controle/setAguardando', true)
      
      // Atualizar store
      await this.$store.commit('veiculo/SET_SITUACAO', this.situacaoFiltro)
      await this.$store.commit('veiculo/SET_TIPO', this.tipoFiltro)
      await this.$store.commit('veiculo/SET_TEXTO_PESQUISA', this.textoPesquisa)

      try {
        const response = await this.$store.dispatch('veiculo/GET_LISTA')
        this.lista = response.data || []
      } catch (error) {
        console.error('Erro ao buscar veículos:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Erro ao buscar veículos')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    limparFiltro () {
      this.situacaoFiltro = '9'
      this.tipoFiltro = '0'
      this.textoPesquisa = ''
      this.$store.commit('veiculo/SET_LIMPAR')
      this.pesquisar()
    },
    novo () {
      this.$router.push({ name: 'VeiculoCadastroNovo' })
    },
    edit (item) {
      this.$store.commit('veiculo/SET_REGISTRO_SELECIONADO_ID', item.ID)
      this.$router.push({ name: 'VeiculoCadastroEditar', params: { id: item.ID } })
    },
    excluir (item) {
      this.veiculoSelecionado = item
      this.$bvModal.show('modal-excluir')
    },
    async confirmarExclusao () {
      try {
        await this.$http.post('/api/protected/veiculo/delete', {
          id: this.veiculoSelecionado.ID,
          login: localStorage.getItem('login')
        })
        
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Veículo excluído com sucesso!')
        
        this.pesquisar()
      } catch (error) {
        console.error('Erro ao excluir veículo:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Erro ao excluir veículo')
      }
    },
    exportarExcel () {
      // TODO: Implementar exportação para Excel
      Tools.exibirMensagem(this.$store, 'Em Desenvolvimento', 'info', 'Funcionalidade de exportação em desenvolvimento')
    },
    exportarHtml () {
      // TODO: Implementar impressão
      Tools.exibirMensagem(this.$store, 'Em Desenvolvimento', 'info', 'Funcionalidade de impressão em desenvolvimento')
    },
    getTipoLabel (tipo) {
      const tipos = {
        '1': 'Carro',
        '2': 'Moto',
        '3': 'Cavalinho',
        '4': 'Carreta',
        '5': 'Caçamba',
        '6': 'Trator',
        '7': 'Balsa',
        '8': 'Barco',
        '9': 'Caminhão'
      }
      return tipos[tipo] || 'N/D'
    },
    getTipoVariant (tipo) {
      const variants = {
        '1': 'info',
        '2': 'warning',
        '3': 'primary',
        '4': 'success',
        '5': 'secondary',
        '6': 'dark',
        '7': 'info',
        '8': 'primary',
        '9': 'danger'
      }
      return variants[tipo] || 'secondary'
    },
    getCombustivelLabel (combustivel) {
      const combustiveis = {
        '1': 'Gasolina',
        '2': 'Álcool',
        '3': 'Diesel',
        '4': 'GNV',
        '5': 'Flex',
        '6': 'Outros'
      }
      return combustiveis[combustivel] || 'N/D'
    },
    getCombustivelVariant (combustivel) {
      const variants = {
        '1': 'danger',
        '2': 'success',
        '3': 'warning',
        '4': 'info',
        '5': 'primary',
        '6': 'secondary'
      }
      return variants[combustivel] || 'secondary'
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.page-col {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/veiculo/VeiculoListagem.vue